import React from 'react';
import { Box, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { Incident } from '../../types';
import { timestampCellContainerStyles } from './styles';

interface TimestampCellProps {
  params: GridRenderCellParams<Incident, string>;
  formatTimestamp: (timestamp: string) => string;
}

const TimestampCell: React.FC<TimestampCellProps> = ({
  params,
  formatTimestamp,
}) => {
  return (
    <Box sx={timestampCellContainerStyles}>
      <Typography variant='body2' color='textSecondary'>
        {params.value ? formatTimestamp(params.value) : '-'}
      </Typography>
    </Box>
  );
};

TimestampCell.displayName = 'TimestampCell';

export default TimestampCell;
